module.exports = __webpack_public_path__ + "static/media/Slide17.464b7679.jpg";